import React from "react";
import {domToReact} from "html-react-parser";
import Marker from "../../../interactive_svg/marker";

const RenderedMarker = ({node, options}) => {
  const targetContainerId = node.attribs["data-target-container-id"]
  const targetContainerQuerySelector = node.attribs["data-target-container"]
  const targetElementId = node.attribs["data-target-element-id"]
  const targetElementQuerySelector = node.attribs["data-target-element"]
  const centerOnTarget = node.attribs["data-center-on-target"] === "true"
  const offsetX = Number(node.attribs["data-offset-x"]) || 0
  const offsetY = Number(node.attribs["data-offset-y"]) || 0

  return <Marker
    targetContainerId={targetContainerId}
    targetContainerQuerySelector={targetContainerQuerySelector}
    targetElementQuerySelector={targetElementQuerySelector}
    targetElementId={targetElementId}
    centerOnTarget={centerOnTarget}
    offsetX={offsetX}
    offsetY={offsetY}
  >
    {domToReact(node.children, options)}
  </Marker>
}

export default RenderedMarker